import React, { useState } from "react";
import "../Assessts/Styles/OurBoard.scss";
import { Images } from "../ReUableComponents/CommonElements";
import OBB from "../Assessts/Images/OurBoard/OBB.png";
// import OBBG from "../Assessts/Images/OurBoard/OBBG.png";
import IOText from "../ReUableComponents/ImageOntext";
import Pic1 from "../Assessts/Images/OurBoard/Pic1.png";
import Pic2 from "../Assessts/Images/OurBoard/Pic2.png";
import Pic3 from "../Assessts/Images/OurBoard/Pic3.png";
import Pic4 from "../Assessts/Images/OurBoard/Pic4.png";
import Pic5 from "../Assessts/Images/OurBoard/Pic5.png";
import Pic6 from "../Assessts/Images/OurBoard/Pic6.png";
import Pic7 from "../Assessts/Images/OurBoard/Pic7.png";
import Pic8 from "../Assessts/Images/OurBoard/Pic8.png";
import Pic9 from "../Assessts/Images/OurBoard/Pic9.png";
const OurBoard = () => {
  const [SCC, SetSCC] = useState(false);
  const [SPP, SetSPP] = useState(false);

  const Data = [
    {
      IMage: Pic1,
      Name: "Mr. Kode Durga Prasad IPS (Retd.)",
      Position: "Chairman",
      Content: (
        <div className="BM-Content ">
          <div>
            <span>
              <p className="mb-3">
                Mr. Durga Prasad is a distinguished IPS officer from the 1981
                Batch. He has served the nation in many critical roles –
                Director General of CRPF, Chief of Special Protection Group in
                charge of security for the PM of India, Additional DGP of
                Greyhounds, Commissioner of Police Vizag, Jt Managing Director,
                AP Transmission Corp etc. He has been honoured with many awards
                such as President’s Police Medal for Distinguished Service,
                India Police Medal, Antrik Suraksha Seva Medal and SPG medal. He
                is presently associated with educational Societies – Vignana
                Jyothi and GITAM. He is on the Boards of NAVA, CCL Products and
                Zen Technologies
              </p>
            </span>
          </div>
          <p>
            Mr. Prasad received his B.Com.(Hons) from IIMC, Osmania University
          </p>
        </div>
      ),
    },
    {
      IMage: Pic2,
      Name: "Dr. Chalasani Mallikarjuna Rao",
      Position: "Managing Trustee",
      Content: (
        <div className="BM-Content ">
          <div>
            <p className="mb-3">
              Dr. Rao Chalasani had a 31-year career with General Motors. Most
              of it was at the GM Tech Center in the US. He worked with GM India
              from 2008 until retirement in 2015. Prior to joining GM, Rao
              worked as a Member of the Technical Staff at the AT&T Bell
              Laboratories. In the US, Rao served as Chairman of the Board of
              Bharatiya Temple in Troy, Michigan, as well as Chairman of TANA
              Foundation
            </p>
          </div>
          <p>
            Dr. Rao received his B.E. (Hons.) degree in Mech. Engg. from the
            Univ of Madras, MS from Wayne State Univ, and Ph.D. degree from the
            Univ of Michigan.
          </p>
        </div>
      ),
    },
    {
      IMage: Pic3,
      Name: "Mr. Jetty Siva Rama Prasad",
      Position: "Trustee",
      Content: (
        <div className="BM-Content ">
          <div>
            <p className="mb-3">
              Mr. Prasad has a distinguished career in Finance and Industry. He
              is currently serving as the Promoter, Chairman, and Director of
              several Power Systems Manufacturing companies. He is also actively
              involved as the Treasurer for Basavatarakam Indo-American Cancer
              Hospital and Research Institute, and Indo-American Research
              Foundation.
            </p>
          </div>
          <p>
            Mr. Prasad has a B Com degree and is also a Fellow Chartered
            Accountant (FCA).
          </p>
        </div>
      ),
    },
    {
      IMage: Pic4,
      Name: "Mr. S.C. Choudhury",
      Position: "Trustee",
      Content: (
        <div className="BM-Content ">
          <div>
            <span>
              <p className="mb-2">
                S.C. Choudhury, retired Chief Commissioner of Customs & Central
                Excise, is a distinguished former officer of the Indian Revenue
                Service. Over his long career, he held key positions in Customs,
                Excise, and Anti-Smuggling enforcement, and served for six years
                on the Central Board of Excise and Customs. He was recognized by
                Business Today as one of India’s national policy makers. His
                official duties took him across India, as well as to the USA,
                USSR, and Europe.
              </p>
              <p>
                In 1993, he founded Vikash Educational Charitable Trust, which
                supports over 800 underprivileged students annually in Odisha
                and Andhra Pradesh with scholarships and free IAS coaching.
                {SCC &&
                  "He has also upgraded government schools with modern infrastructure and technology. As Trustee of North South Foundation (USA) and Secretary of SEEDS India Trust, he works to bring global educational support to local communities. Choudhury remains deeply committed to education, equity, and youth empowerment."}
                <span
                  className="Web-SubHeading CPointer"
                  onClick={() => SetSCC(!SCC)}
                >
                  Read {SCC ? "Less" : "More"}
                </span>
              </p>
            </span>
          </div>
          <p>
            Mr. S.C. Choudhury is a distinguished former Indian Revenue Service
            officer.
          </p>
        </div>
      ),
    },
    {
      IMage: Pic5,
      Name: "Ms. Sandhya Rani Kanneganti",
      Position: "Trustee",
      Content: (
        <div className="BM-Content ">
          <div>
            <p className="mb-3">
              Ms. Sandhya Kanneganti is a career civil servant from Indian
              Postal Services, 1987 batch. She worked across multiple sectors
              including postal services, banking and financial inclusion, rural
              development and poverty alleviation and school education. After
              retirement she has been actively engaged with several NGOs. She is
              Trustee of North South Foundation, India and Chairperson of NCP.
            </p>
          </div>
          <p>
            Ms. Sandhya Kanneganti has Masters in Political Science from
            Hyderabad Central University and Masters in Public Administration
            from Harvard University.
          </p>
        </div>
      ),
    },
    {
      IMage: Pic6,
      Name: "Mr. Prasad Chowdary Chitturi",
      Position: "Trustee",
      Content: (
        <div className="BM-Content ">
          <div>
            <p className="mb-3">
              Prasad Chowdary Chitturi is an entrepreneur and business leader
              committed to education and community service. He leads Chowdary
              Spinners Pvt. Ltd., a textile firm known for innovation and
              process excellence, and coordinates the North South Foundation
              Tanuku Chapter. He has served Rotary International as Club
              President, District Secretary, Assistant Governor (Dist. 3020),
              and led a Group Study Exchange Team to the USA. He was also a
              trustee of Surya Devalayam, Tanuku, and remains active in textile
              industry forums.
            </p>
          </div>
          <p>
            He holds a B.E. in Electronics & Communication from CIT, Coimbatore,
            and an Executive MBA (PGPMAX) from ISB.
          </p>
        </div>
      ),
    },
    {
      IMage: Pic7,
      Name: "Mr. Surya Prasad Padala",
      Position: "Trustee",
      Content: (
        <div className="BM-Content ">
          <div>
            <span>
              <p className="mb-2">
                Mr. Surya Prasad Padala is the founder and C.E.O. of Padala
                Charitable Trust, a non-profit organization based in Kakinada,
                Andhra Pradesh. After working in the US for 16 years in the
                software domain Mr. Padala decided to move back to India and
                work full time towards the upliftment of the less fortunate.
              </p>
              {SPP && (
                <>
                  <p className="mb-2">
                    {" "}
                    Mr. Surya Prasad holds a B.Tech from JNTUK and M.Tech from
                    IIT Kharagpur in Mechanical Engineering. He is proud to be
                    one of the first recipients of NSF Scholarship which helped
                    him immensely when pursuing his graduation.
                  </p>
                  <p>
                    One thing that drives Surya Prasad’s passion is the very
                    idea of paying it forward. Adolescent Education and
                    Empowerment is the area that Surya Prasad and his team has
                    been working for last 23 yrs.
                  </p>
                </>
              )}
              <p>
                {" "}
                <span
                  className="Web-SubHeading CPointer"
                  onClick={() => SetSPP(!SPP)}
                >
                  Read {SPP ? "Less" : "More"}
                </span>{" "}
              </p>
            </span>
          </div>
          <p>
            Mr. Surya Prasad Padala holds a B.Tech degree from JNTUK and an
            M.Tech in Mechanical Engineering from IIT Kharagpur. He is among the
            first recipients of the NSF Scholarship.{" "}
          </p>
        </div>
      ),
    },
    {
      IMage: Pic8,
      Name: "Ms. C. Rama Devi",
      Position: "Trustee",
      Content: (
        <div className="BM-Content ">
          <div>
            <span>
              <p className="mb-2">
                Ms. C. Rama Devi brings over 40 years of distinguished service
                in school education, having served as Teacher, Supervisor, Vice
                Principal, and Senior Principal at BVB Public School, Jubilee
                Hills. She currently serves as Director (Coordination) at
                Bharatiya Vidya Bhavan, Hyderabad Kendra. She has conducted
                numerous CBSE Capacity Building Workshops and contributed
                articles to Teacher Plus, Mentor, leading newspapers, and
                authored a Telugu book. Her global exposure includes educational
                exchanges across the UK, USA, Hong Kong, Japan, Singapore, Sri
                Lanka, and the Andaman & Nicobar Islands. She has been honoured
                with the CBSE Best Teacher Award (2006), Jindal Best Teacher
                Award (2008), and the National Award to Teachers (2010) by the
                President of India.
              </p>
              {/* {SPP && <><p className="mb-2"> Mr. Surya Prasad holds a B.Tech from JNTUK and M.Tech from IIT Kharagpur in Mechanical Engineering. He is proud to be one of the first recipients of NSF Scholarship which helped him immensely when pursuing his graduation.</p>
                            <p>One thing that drives Surya Prasad’s passion is the very idea of paying it forward. Adolescent Education and Empowerment is the area that Surya Prasad and his team has been working for last 23 yrs.</p></>
                        } */}
              {/* <p> <span className="Web-SubHeading CPointer" onClick={() => SetSPP(!SPP)}>Read {SPP ? "Less" : "More"}</span> </p> */}
            </span>
          </div>
          <p>Ms. Rama Devi is a postgraduate with an M.Phil in Education.</p>
        </div>
      ),
    },
    {
      IMage: Pic9,
      Name: "Mr. Sivakumar Vavilala",
      Position: "Trustee",
      Content: (
        <div className="BM-Content ">
          <div>
            <span>
              <p className="mb-2">
                Siva Vavilala is a seasoned technology executive with over 30
                years of leadership experience spanning global corporations and
                startups across the USA, India, Europe, UK, and New Zealand.
                Beyond his professional career, Siva has dedicated more than two
                decades to community service through the NorthSouth Foundation
                (NSF). As Founding Director of the Indianapolis Chapter, he led
                contests, coaching, fundraising, and volunteer recruitment for
                15 years, while also conceptualizing mentorship and academic
                initiatives. His commitment earned him nomination as Trustee of
                NSF India, strengthening cross-border educational and
                philanthropic engagement. He holds an MBA from Indiana
                University’s Kelley School of Business and an MS in Applied
                Electronics from Osmania University.
              </p>
              {/* {SPP && <><p className="mb-2"> Mr. Surya Prasad holds a B.Tech from JNTUK and M.Tech from IIT Kharagpur in Mechanical Engineering. He is proud to be one of the first recipients of NSF Scholarship which helped him immensely when pursuing his graduation.</p>
                            <p>One thing that drives Surya Prasad’s passion is the very idea of paying it forward. Adolescent Education and Empowerment is the area that Surya Prasad and his team has been working for last 23 yrs.</p></>
                        } */}
              {/* <p> <span className="Web-SubHeading CPointer" onClick={() => SetSPP(!SPP)}>Read {SPP ? "Less" : "More"}</span> </p> */}
            </span>
          </div>
          {/* <p>Mr. Surya Prasad Padala holds a B.Tech degree from JNTUK and an M.Tech in Mechanical Engineering from IIT Kharagpur. He is among the first recipients of the NSF Scholarship. </p> */}
        </div>
      ),
    },
  ];
  return (
    <>
      <div className="Single_Banner mt-2">
        <IOText
          Image={OBB}
          Alt="EMpower"
          Text={
            <div className="Text-MainDiv">
              <div></div>
              <div>
                Leadership committed to
                <span style={{ color: "#F7D670" }}> transparency</span>,{" "}
                <span style={{ color: "#F7D670" }}>sustainability</span>, and{" "}
                <span style={{ color: "#F7D670" }}>organizational</span>{" "}
                excellence
              </div>
              <div className="mt-2 Text-Content">
                <span style={{ color: "#F7D670" }}> Home </span> &gt; Our Board
              </div>
            </div>
          }
        />
      </div>

      <div className="Web-MainHeading m-2">Our Board</div>
      {Data.map((Content) => (
        <div className="Card dflex gap-3 p-4 Board-members">
          <div>
            <div
              className="Web-MainHeading"
              style={{ justifyContent: "flex-start" }}
            >
              {Content?.Name}
            </div>
            <div className="Web-SubHeading mb-2">{Content?.Position}</div>
            {Content?.Content}
          </div>
          <img src={Content?.IMage} alt={Content?.Name} />
        </div>
      ))}
    </>
  );
};
export default OurBoard;
